<template>
  <span>{{localText}}</span>
</template>

<script lang="ts">
  import Vue from "vue";
  import DatetimeHelper from "../helpers/datetimeHelper";

  export default Vue.extend({
    props: {
      value: {
        type: String
      }
    },
    data: function() {
      return {};
    },
    computed: {
      localText() {
        return DatetimeHelper.toLocalTimeString(this.value);
      }
    }
  });
</script>